import { FunctionComponent } from "react";
import Logout from "./pages/Logout";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import EditProfile from "./pages/Profile/Edit";
import ClientPage from "./pages/Client/";
import ClientForm from "./pages/Client/Form";
import ClientNew from "./pages/Client/New";
import ForgotPassword from "./pages/ForgotPassword";
import SetPassword from "./pages/SetPassword";
import EditClient from "./pages/Client/Edit";
import User from "./pages/Admin/User";
import ChangePassword from "./pages/ChangePassword";

type RouteType = {
  path: string;
  name: string;
  Component: FunctionComponent<unknown>;
  authenticated: boolean;
};

type RoutesType = RouteType[];

export const routes: RoutesType = [
  { path: "/", name: "Home", Component: Home, authenticated: true },
  { path: "/logout", name: "Logout", Component: Logout, authenticated: false },
  {
    path: "/timeout",
    name: "Timeout",
    Component: Logout,
    authenticated: false,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    Component: Dashboard,
    authenticated: true,
  },
  {
    path: "/profile",
    name: "Profile",
    Component: Profile,
    authenticated: true,
  },
  {
    path: "/profile/edit",
    name: "Edit Profile",
    Component: EditProfile,
    authenticated: true,
  },
  {
    path: "/client/:client_id(\\d+)",
    name: "Client Profile",
    Component: ClientPage,
    authenticated: true,
  },
  {
    path: "/client/:client_id(\\d+)/form/:file_id(\\d+)",
    name: "Client Form",
    Component: ClientForm,
    authenticated: true,
  },
  {
    path: "/client/new",
    name: "Client New",
    Component: ClientNew,
    authenticated: true,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    Component: ForgotPassword,
    authenticated: false,
  },
  {
    path: "/set-password",
    name: "Set Password",
    Component: SetPassword,
    authenticated: false,
  },
  {
    path: "/client/:client_id(\\d+)/edit",
    name: "Edit Client",
    Component: EditClient,
    authenticated: true,
  },
  {
    path: "/user/:user_id",
    name: "User",
    Component: User,
    authenticated: true,
  },
  {
    path: "/change-password",
    name: "Change Password",
    Component: ChangePassword,
    authenticated: true,
  },
];
